import ApplicationController from './editor/application_controller.js';

export default class extends ApplicationController {
  beforeTakeAttendance(element) {
    element.classList.add(element.dataset.activeBgClass);
  }
}
